class EventParametersModel {
  constructor({ parameters = {} } = {}) {
    this.parameters = parameters;
  }
  json() {
    return {
      parameters: this.parameters,
    };
  }
  type(value) {
    switch (typeof value) {
      case "number":
        if (Math.ceil(parseFloat(value)) === value) {
          return "integer";
        } else {
          return "float";
        }
        break;
      default:
        return typeof value;
    }
  }
  list() {
    let ls = [];
    try {
      for (param in this.parameters) {
        console.error("PARAM", param);
        let _ = {};
        _.key = param;
        _.value = { [this.type(value)]: this.parameters.param.value };
        ls.push(_);
      }
    } catch (err) {
      console.error("list()", err);
    }
    return ls;
  }
}

module.exports = EventParametersModel;
